import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components';
import { CategoriesPanel } from './categories/CategoriesPanel';
import { RecordsPanel } from './records/RecordsPanel';
import { TemplatesPanel } from './templates/TemplatesPanel';

type TabValue = 'templates' | 'records' | 'categories';

const NotificationConfigsPage = () => {
  const t = useTranslate();
  const [tab, setTab] = useState<TabValue>('templates');

  return (
    <DashboardContent>
      <PermissionGuard resource="notification-configs" action="read" fallback={<ErrorPage403 />}>
      <CustomBreadcrumbs
        heading={t('resource.notificationConfigs', { _: 'Notification Configs' })}
      />
      <Tabs
        value={tab}
        onChange={(_, value: TabValue) => setTab(value)}
        sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab
          value="templates"
          label={t('module.notificationConfigs.templatesTab', { _: 'Notification Templates' })}
        />
        <Tab
          value="categories"
          label={t('module.notificationConfigs.categoriesTab', { _: 'Notification Categories' })}
        />
        <Tab
          value="records"
          label={t('module.notificationConfigs.recordsTab', { _: 'Notification Records' })}
        />
      </Tabs>

      {tab === 'templates' && <TemplatesPanel />}
      {tab === 'records' && <RecordsPanel />}
      {tab === 'categories' && <CategoriesPanel />}
      </PermissionGuard>
    </DashboardContent>
  );
};

export default NotificationConfigsPage;
